import storageActions from "app/utils/storageActions";

import { initialState as initialValueState } from "app/redux/reducers/value";

const initialState = [initialValueState, initialValueState];

export const values = (state = initialState, action) => {
  // Check to see if the reducer cares about this action
  if (action.type === "values/index") {
    // console.log('setting values in store: ', action.values)
    storageActions.saveItem("values", action.values);
    return [...action.values];
  } else if (action.type === "values/add") {
    let values = [...state];
    for (let av of action.values) {
      let index = values.findIndex((v) => v.id == av.id);
      if (index >= 0) values[index] = { ...values[index], ...av };
      else values.push(av);
    }
    return values;
  } else if (action.type === "values/create") {
    let values = [...state, action.value];
    if (!!action.value.parent_ids?.length) {
      values = values.map((v) =>
        action.value.parent_ids.includes(v.id)
          ? {
              ...v,
              child_ids: [...(v.child_ids || []), action.value.id],
            }
          : v
      );
    }
    if (!!action.value.child_ids?.length) {
      values = values.map((v) =>
        action.value.child_ids.includes(v.id)
          ? {
              ...v,
              parent_ids: [...v.parent_ids, action.value.id],
            }
          : v
      );
    }
    // const values = [...state, action.value];
    storageActions.saveItem("values", values);
    return values;
  } else if (action.type === "value/update") {
    // console.log('updating value', action)
    let values = [...state];
    values = values.map((v) =>
      v.id == action.value.id
        ? {
            ...v,
            ...action.value,
            // parent_ids: !!action.value.parent_ids ? action.value.parent_ids : v.parent_ids,
            // progress_at: !!action.value.progress_at ? action.value.progress_at : v.progress_at,
          }
        : v
    );
    storageActions.saveItem("values", values);
    return values;
  } else if (action.type === "value/delete") {
    // console.log('deleting value', action)
    let values = state.filter((v) => v.id != action.id);
    storageActions.saveItem("values", values);
    return values;
  } else if (action.type === "values/replace_temp") {
    let values = state.filter((v) => v.id !== action.tempId);
    values.push(action.value);
    storageActions.saveItem("values", values);
    return values;
  }
  // otherwise return the existing state unchanged
  return state;
};
